import { render, staticRenderFns } from "./DNC.vue?vue&type=template&id=79fab586"
import script from "./DNC.vue?vue&type=script&lang=js"
export * from "./DNC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports